<app-maintenance-window />
@if (appShellLoading()) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center"
    [class.bg-[#f9f9f9]]="!darkModeService.darkModeOn()"
    [class.bg-neutral-950]="darkModeService.darkModeOn()"
    [attr.data-theme]="darkModeService.darkModeOn() ? 'dark' : 'light'"
  >
    <joii-loader />
  </div>
}
<app-vetai-header
  [config]="menu"
  [showSubMenu]="false"
  [setWhitebackground]="false"
  [sourceProject]="'PMS'"
  [ngClass]="{ dark: darkModeService.darkModeOn() }"
  [attr.data-theme]="darkModeService.darkModeOn() ? 'dark' : 'light'"
>
  <router-outlet></router-outlet>
</app-vetai-header>
